import * as React from 'react';
import { GridDayProps } from '../../components/grid/day';

import * as moment from 'moment';
import GridEventView from '../../components/grid/event';

const GridDayView: React.StatelessComponent<GridDayProps> = props => {
    const dateMoment = moment(props.day.date);

    return (
        <li className={`ace-cal-grid-day ${props.day.events.length > 0 ? "ace-cal-grid-day-has-events" : ""} ${props.isToday ? "ace-cal-grid-day-today" : ""}`} aria-labelledby={`Day-${dateMoment.format("X")}`}>
            {
                props.day.events.length > 0 ?
                    <article className="ace-cal-grid-day-content">
                        <span aria-hidden="true" role="presentation" className="ace-cal-grid-day-date">{dateMoment.format("D")}</span>
                        <h3 id={`Day-${dateMoment.format("X")}`} className="visually-hidden">
                            {
                                <span role="text">
                                    {`${dateMoment.format("dddd, MMMM")} ${dateMoment.format("D")}`}
                                    <span>{`: ${props.day.events.length} ${props.day.events.length > 2 ? props.text.pluralEventsText : props.text.singleEventText}`}</span>
                                </span>
                            }
                        </h3>
                        <ul className="ace-cal-grid-day-content">
                            {
                                props.day.events.map(event => <GridEventView key={event.id} event={event} />)
                            }
                        </ul>
                    </article>
                    :
                    <div className="ace-cal-grid-day-content">
                        <span className="ace-cal-grid-day-date" id={`Day-${dateMoment.format("X")}`} role="text"><span className="visually-hidden">{`${dateMoment.format("dddd, MMMM")} `}</span>{dateMoment.format("D")}</span>
                    </div>
            }
        </li>
    );
}

export default GridDayView;